export const getParentElement = () =>
  document.getElementById('modules-merchant-orders') || document.getElementById('modules');



// WEBPACK FOOTER //
// ./src/helpers/modal.js